import { useEffect, useRef } from "react";

export function useDebouncedEffect(
  callback: () => void,
  delay: number,
  dependencies: unknown[],
) {
  const timeoutRef = useRef<NodeJS.Timeout | undefined>(undefined);

  const callbackRef = useRef(callback);
  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(callbackRef.current, delay);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delay, ...dependencies]);
}
